import Navigation from '../../components/utils/Navigation';
import NoDataAvailable from '../../components/utils/NoDataAvailable.vue';
import moment from 'moment';
import { TICKET_STATUS, TICKET_STATUS_INFO, TICKET_PRIORITY, TICKET_PRIORITY_INFO, populateUsefulMaps } from '../../utils/entityMethods/ticket.js';
import { isValid } from '../../utils/utilitiesmodule.js';

function getDefaultTicketFilters() {
    return {
        id_team: "",
        id_user_assigned: "",
        priority: "",
        status: "",
        dt_inf: moment().subtract(2, 'months').format("YYYY-MM-DD"),
        dt_sup: moment().format("YYYY-MM-DD"),
        invoiced: "",
        offset: 0,
        limit: 50
    };
}

export default {
    name: "Tickets",
    components: { Navigation, NoDataAvailable },
    data() {
        return {
            TICKET_STATUS,
            TICKET_STATUS_INFO,
            TICKET_PRIORITY_INFO,
            tickets: null,
            teams: [],
            filterTeamOperators: [],
            isAdmin: false,
            isTeamLeader: false,
            showFilters: false,
            menuTicket: null,
            menuStyle: { top: "0px", left: "0px" },
            menuButtonRect: null,
            filters: getDefaultTicketFilters(),
            wsTopic: null,
            wsHandler: null
        };
    },
    async mounted() {
        if (!this.$root.checkAuth()) return;
        this.$session.setRoomPC(null);
        if (this.$root.socket) this.$root.socket("SETPC", null);

        await this.populateUsefulMaps();
        this.isAdmin = this.$root.authObj.roles == 'Admin';
        this.isTeamLeader = this.$root.userLoggedIsLeadOfSomeTeam;
        this.teams = Object.values(this.$root.teamMap);
        this.refreshOperatorFilter();
        await this.getTickets(false);
        this.subscribeRealtime();
        document.addEventListener('click', this.handleDocumentClick);
    },
    beforeDestroy() {
        this.unsubscribeRealtime();
        document.removeEventListener('click', this.handleDocumentClick);
    },
    methods: {
        populateUsefulMaps,

        async getTickets(applyFilters) {
            if (applyFilters) this.filters.offset = 0;
            await this.populateUsefulMaps();
            const cleanFilters = this.buildCleanFilters();
            this.tickets = await this.$api.getTickets(cleanFilters);

            this.showFilters = this.tickets.length === 0;
        },
        buildCleanFilters() {
            const out = {};
            for (const f in this.filters) {
                if (!isValid(this.filters[f])) continue;
                out[f] = this.filters[f];
            }
            // Conversione date al formato server (una sola volta, fuori dal loop)
            if (out.dt_inf) out.dt_inf = moment(out.dt_inf).format("YYYYMMDD") + "000000";
            if (out.dt_sup) out.dt_sup = moment(out.dt_sup).format("YYYYMMDD") + "235959";
            return out;
        },
        onFilterTeamChanged() {
            this.filters.id_user_assigned = null;
            this.refreshOperatorFilter();
        },
        async resetFilters() {
            this.filters = getDefaultTicketFilters();
            this.refreshOperatorFilter();
            await this.getTickets(true);
        },
        refreshOperatorFilter() {
            if (!this.filters.id_team) {
                this.filterTeamOperators = [];
                return;
            }

            const team = this.$root.teamMap ? this.$root.teamMap[this.filters.id_team] : null;
            const members = team && Array.isArray(team.users) ? team.users : [];
            this.filterTeamOperators = members
                .map(m => this.$root.userMap ? this.$root.userMap[m.id_user || m.id] : null)
                .filter(Boolean);
        },
        userLabel(user) {
            const fullName = [user.firstname, user.lastname].filter(Boolean).join(" ").trim();
            return fullName ? fullName + " (" + user.username + ")" : user.username;
        },
        formatUtcDate(d) {
            if (!d) return "-";
            // d è una data UTC: la interpreto come UTC e la converto al fuso locale dell'utente.
            return moment.utc(d).local().format("DD/MM/YYYY HH:mm");
        },
        formatDate(d) {
            if (!d) return "-";
            return moment(d).format("DD/MM/YYYY HH:mm");
        },
        // input in secondi
        formatHours(seconds) {
            if (seconds == null) return "-";
            const s = Math.floor(Number(seconds));
            if (s === 0) return "0s";
            const h = Math.floor(s / 3600);
            const m = Math.floor((s % 3600) / 60);
            const sec = s % 60;
            if (h > 0) return h + "h" + (m > 0 ? " " + m + "m" : "");
            if (m > 0) return m + "m" + (sec > 0 ? " " + sec + "s" : "");
            return sec + "s";
        },
        durationLabel(minutes) {
            if (minutes == null) return "-";
            const h = Math.floor(minutes / 60);
            const m = minutes % 60;
            return (h > 0 ? h + "h " : "") + m + "m";
        },
        isClosedStatus(status) {
            return [TICKET_STATUS.COMPLETED, TICKET_STATUS.CANCELLED].includes(Number(status));
        },
        isReadOnlyStatus(status) {
            return [TICKET_STATUS.COMPLETED, TICKET_STATUS.CANCELLED].includes(Number(status));
        },
        canOpenMenu(ticket) {
            if (!ticket) return false;
            return !this.isClosedStatus(ticket.status) || this.isReadOnlyStatus(ticket.status);
        },


        toggleMenu(r, ev) {
            ev.stopPropagation();
            if (this.menuTicket && this.menuTicket.id === r.id) {
                this.closeMenu();
                return;
            }
            const rect = ev.currentTarget.getBoundingClientRect();
            this.menuButtonRect = rect;
            const MENU_WIDTH = 200;
            const left = Math.max(8, Math.min(rect.right - MENU_WIDTH, window.innerWidth - MENU_WIDTH - 8));
            this.menuStyle = {
                top: rect.bottom + 4 + "px",
                left: left + "px",
                minWidth: MENU_WIDTH + "px"
            };
            this.menuTicket = r;
            this.$nextTick(this.positionMenu);
        },
        positionMenu() {
            if (!this.menuTicket || !this.menuButtonRect || !this.$refs.ticketMenu) return;

            const rect = this.menuButtonRect;
            const menu = this.$refs.ticketMenu;
            const MENU_WIDTH = 200;
            const MARGIN = 8;
            const GAP = 4;
            const left = Math.max(MARGIN, Math.min(rect.right - MENU_WIDTH, window.innerWidth - MENU_WIDTH - MARGIN));
            const availableBelow = window.innerHeight - rect.bottom - GAP - MARGIN;
            const availableAbove = rect.top - GAP - MARGIN;
            const menuHeight = menu.offsetHeight || 0;
            const openAbove = menuHeight > availableBelow && availableAbove > availableBelow;
            const maxHeight = Math.max(80, openAbove ? availableAbove : availableBelow);
            const top = openAbove
                ? Math.max(MARGIN, rect.top - GAP - Math.min(menuHeight, maxHeight))
                : Math.min(rect.bottom + GAP, window.innerHeight - MARGIN - Math.min(menuHeight, maxHeight));

            this.menuStyle = {
                top: top + "px",
                left: left + "px",
                minWidth: MENU_WIDTH + "px",
                maxHeight: maxHeight + "px"
            };
        },
        closeMenu() {
            this.menuTicket = null;
            this.menuButtonRect = null;
        },
        handleDocumentClick() {
            this.closeMenu();
        },

        openTicket(r) {
            this.$router.push({
                name: "ticket",
                params: {
                    idTicket: r.id,
                }
            });
        },
        async changeTicketStatus(ticket, status) {
            if (ticket.status == status) return;
            ticket.status = status;
            if ([TICKET_STATUS.PENDING, TICKET_STATUS.RELEASED].includes(ticket.status)) {
                ticket.id_team = null;
                ticket.id_user_assigned = null;
            }
            const result = await this.$api.editTicket(ticket.id, ticket);
            if (result != null) await this.getTickets(false);
        },

        async deleteTicket(r) {
            const dialogId = Math.floor(100000 + Math.random() * 900000).toString();
            const self = this;
            this.$root.$on(dialogId, async ok => {
                if (ok) {
                    const result = await self.$api.deleteTicket(r.id, r.title);
                    if (result) await self.getTickets(false);
                }
                self.$root.$off(dialogId);
            });
            this.$root.openYesNoDialog(
                dialogId,
                this.$t("Delete ticket"),
                this.$t("deleteConfirmation", { 0: r.title || ('#' + r.id) })
            );
        },

        exportCsv() {
            if (!this.tickets || this.tickets.length === 0) {
                if (this.$root.createToastFunction) this.$root.createToastFunction(this.$t("No data to export"), "alert");
                return;
            }
            const header = ["ID", "PC", "Computer name", "Customer", "Team", "Title", "Operator", "Status", "Priority", "Duration (min)", "Registered", "Closed"];
            const rows = this.tickets.map(r => [
                r.id,
                r.id_remote,
                r.pc_name || "",
                r.customer_name || "",
                r.team_name || "",
                (r.title || "").replace(/"/g, '""'),
                r.operator_name || "",
                TICKET_STATUS_INFO[r.status] ? this.$t(TICKET_STATUS_INFO[r.status].label) : "",
                TICKET_PRIORITY_INFO[r.priority] ? this.$t(TICKET_PRIORITY_INFO[r.priority].label) : "",
                r.duration_minutes != null ? r.duration_minutes : "",
                this.formatDate(r.dt_registered),
                this.formatDate(r.dt_done)
            ]);
            const csv = [header, ...rows].map(line => line.map(v => '"' + (v != null ? v : "") + '"').join(",")).join("\n");
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "tickets_" + moment().format("YYYYMMDD_HHmmss") + ".csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },

        subscribeRealtime() {
            const license = this.$session && this.$session.getLicense ? this.$session.getLicense() : null;
            if (!license || !this.$root.subscribeTopic) return;
            this.wsTopic = "license:" + license.id_masteraccount;
            this.wsHandler = (event) => this.onRealtimeEvent(event);
            this.$root.subscribeTopic(this.wsTopic, this.wsHandler);
        },
        unsubscribeRealtime() {
            if (this.wsTopic && this.$root.unsubscribeTopic) {
                this.$root.unsubscribeTopic(this.wsTopic, this.wsHandler);
            }
        },
        onRealtimeEvent(event) {
            if (!event || !event.type) return;
            switch (event.type) {
                case "request_new":
                case "request_assigned":
                case "request_released":
                case "request_reassigned":
                case "request_cancelled":
                case "request_completed":
                    this.getTickets(false);
                    break;
            }
        }
    }
};
